/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SmileySad(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm81.58545,86.9248a7.99636,7.99636,0,0,1-10.93018-2.91943,40.01579,40.01579,0,0,0-69.30957-.00049,8.00016,8.00016,0,0,1-13.85058-8.01074,56.0156,56.0156,0,0,1,97.00976.00049A7.99915,7.99915,0,0,1,173.58545,182.9248Z" />
    </Svg>
  );
}

export default SmileySad;
